import { render, staticRenderFns } from "./StyleViewPrices.vue?vue&type=template&id=342c0ac0&"
import script from "./StyleViewPrices.vue?vue&type=script&lang=js&"
export * from "./StyleViewPrices.vue?vue&type=script&lang=js&"
import style0 from "./StyleViewPrices.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports